import { fetchQuery } from 'react-relay';
import environment from 'shared/relay/environment';
import updateStatusQuery from './updateStatus.query';

export default function queryStatusData(packageId) {
  return new Promise((resolve, reject) => {
    fetchQuery(environment, updateStatusQuery, {
      packageId
    })
      .then(queryProps => resolve(queryProps))
      .catch(error => reject(error));
  });
}
